import React from 'react'
import ChatButtonIcon from '../Icons/ChatButtonIcon';

const ChatButton = ({
  label = 'Ask a question',
  onClick,
  className = '',
  disabled = false,
  loading = false,
  visible = true,
  icon: Icon = ChatButtonIcon,
  config = {},
  ...props
}) =>  {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        bubble-chat-button
        flex
        items-center
        font-inter-variable
        gap-v3-xs
        p-v3-sm
        rounded-v3-xxl
        bg-[var(--dt-color-brand-100)]
        text-[#FFFFFF]
        shadow-v3-double
        transition-all
        duration-200
        hover:bg-[var(--dt-color-brand-60)]
        disabled:opacity-50
        disabled:cursor-not-allowed
        disabled:hover:border-transparent
        ${className}
      `}
      {...props}
    >
      <Icon className="flex-shrink-0" />
      <span className="font-medium">
        {label}
      </span>
    </button>
  )
}

export default ChatButton